import axios from "axios";
import API_URL from "../Config";

const authHeaders = () => ({
  Authorization: localStorage.getItem("authKey") || "",
});

const isolationTypeMatcher = (name = "") => {
  const normalized = name.toLowerCase();
  return (
    normalized.includes("isolation") || normalized.includes("energisation")
  );
};

export const fetchIsolationPermit = async (permitId) => {
  const response = await axios.get(
    `${API_URL}/api/isolation_permit/${permitId}`,
    {
      headers: authHeaders(),
    },
  );
  return response.data || {};
};

export const createIsolationPermit = async (payload) => {
  const response = await axios.post(
    `${API_URL}/api/isolation_permit/create`,
    payload,
    {
      headers: authHeaders(),
    },
  );
  return response.data || {};
};

export const updateIsolationRequest = async (permitId, payload) => {
  const response = await axios.put(
    `${API_URL}/api/isolation_permit/${permitId}/isolation`,
    payload,
    {
      headers: authHeaders(),
    },
  );
  return response.data || {};
};

export const submitIsolationCertificate = async (permitId, payload) => {
  const response = await axios.put(
    `${API_URL}/api/isolation_permit/${permitId}/isolation_certificate`,
    payload,
    {
      headers: authHeaders(),
    },
  );
  return response.data || {};
};

export const submitEnergisationRequest = async (permitId, payload) => {
  const response = await axios.put(
    `${API_URL}/api/isolation_permit/${permitId}/energisation`,
    payload,
    {
      headers: authHeaders(),
    },
  );
  return response.data || {};
};

export const submitEnergisationCertificate = async (permitId, payload) => {
  const response = await axios.put(
    `${API_URL}/api/isolation_permit/${permitId}/energisation_certificate`,
    payload,
    {
      headers: authHeaders(),
    },
  );
  return response.data || {};
};

export const fetchIsolationPermitTypes = async () => {
  const response = await axios.get(`${API_URL}/api/get_work_permit_types`, {
    headers: authHeaders(),
  });

  const allTypes = response.data?.work_permit_types || [];
  const mapped = allTypes.map((permitType) => ({
    value: permitType.id,
    label: permitType.work_permit_name,
  }));

  const filtered = mapped.filter((type) => isolationTypeMatcher(type.label));
  return filtered.length > 0 ? filtered : mapped;
};

export const fetchDepartmentOptions = async () => {
  const response = await axios.get(`${API_URL}/api/get_departments`, {
    headers: authHeaders(),
  });

  const departments = Array.isArray(response.data) ? response.data : [];
  return departments.map((department) => ({
    value: department.ID,
    label: department.DepartmentName,
  }));
};

export const fetchEquipmentTagOptions = async () => {
  const response = await axios.get(`${API_URL}/api/get_equipment_tag_no`, {
    headers: authHeaders(),
  });

  const items = Array.isArray(response.data?.Items) ? response.data.Items : [];
  return items.map((item) => {
    const tagValue = item.TagNo || item.equipment_no || item.Category || "";
    return {
      value: tagValue,
      label: tagValue,
      equipmentId: item.ID,
    };
  });
};

export const listIsolationPermits = async (status = "") => {
  const response = await axios.get(`${API_URL}/api/isolation_permits`, {
    headers: authHeaders(),
    params: status ? { status } : {},
  });

  return response.data || { permits: [], total: 0 };
};
